import { defineNuxtRouteMiddleware, navigateTo } from '#app';
import { canonicalBlogFirstPage } from '~/utils/blog-pagination';

export default defineNuxtRouteMiddleware((to) => {
  const target = canonicalBlogFirstPage(to);
  if (target) return navigateTo(target, { redirectCode: 301, replace: true });
});
